<script lang="ts" setup>
import { useI18n } from "vue-i18n"

type Props = {
    data: {
        /**
         * Identifiant du bâtiment
         */
        buildingId: string
        /**
         * Nom du bâtiment
         */
        name: string
        /**
         * Adresse du bâtiment
         */
        address: string
        /**
         * Nombre de sources du bâtiment
         */
        sources: number
        /**
         * Valeur de la donnée
         */
        data?: string
        /**
         * Variable de la donnée
         */
        variable?: string
        /**
         * Évolution de la donnée
         */
        evolution?: number
        /**
         * Valeur de l'évolution formatée
         */
        evolutionFormated?: string
        /**
         * Ordre de classement
         */
        rankingOrder?: "asc" | "desc"
        /**
         * Callback lors du clic sur le bouton
         */
        onClick?: (buildingId: string) => void
    }
}

const { t } = useI18n()

withDefaults(defineProps<Props>(), {
    data: () => ({
        name: "",
        address: "",
        sources: 0,
        data: "",
        variable: "",
        evolution: undefined,
        evolutionFormated: "",
        rankingOrder: "desc",
        buildingId: "",
    }),
})
</script>

<template>
    <div class="map-building-popup" v-if="data.address">
        <h1 class="font-semibold whitespace-normal capitalize">
            {{ data.name }}
        </h1>
        <p class="map-building-tooltip__info whitespace-normal capitalize">
            {{ data.address }}
        </p>
        <p class="map-building-tooltip__info whitespace-normal capitalize">
            {{ data.sources }}
            <span>sources</span>
        </p>

        <p v-if="data.data && data.variable">
            {{ t(`variables.${data.variable}.long`) }} :
            <span> {{ data.data }}</span>
        </p>
        <p
            v-if="data.evolutionFormated && data.variable"
            :style="
                data.evolution
                    ? {
                          color:
                              data.evolution > 0
                                  ? data.rankingOrder === 'desc'
                                      ? 'var(--p-red-500)'
                                      : 'var(--p-teal-500)'
                                  : data.rankingOrder === 'asc'
                                    ? 'var(--p-red-500)'
                                    : 'var(--p-teal-500)',
                      }
                    : null
            "
        >
            {{ data.evolutionFormated }}
        </p>
        <BaseButton
            v-if="data.onClick && data.buildingId"
            label="Accéder"
            icon="pi pi-angle-right"
            icon-pos="right"
            rounded
            severity="secondary"
            size="small"
            @click.prevent.stop="data.onClick(data.buildingId)"
        ></BaseButton>
    </div>
</template>

<style scoped>
.map-building-popup {
    display: flex;
    width: 17.5rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    .map-building-tooltip__info {
        color: var(--p-surface-800);
    }
}
</style>
<style>
.custom-popup {
    border-radius: 0.375rem;
    border: 1px solid var(--p-surface-300, #e0e0e0);
    background: #ffffff;
    opacity: 1 !important;
    padding: 0 !important;
    p {
        margin: 0 !important;
    }
}
</style>
